<template>
  <div class="w-full">
    <PaymentSettings
      :form-data="formData"
      :has-invalid-price="hasInvalidPrice"
      :invalid-price-products="invalidPriceProducts"
      :bank-accounts="bankAccounts"
      @validate="validateForm"
    />
  </div>
</template>

<script>
import PaymentSettings from './setting/PaymentSettings.vue'

export default {
  name: 'StepFour',
  components: {
    PaymentSettings,
  },
  props: {
    formData: {
      type: Object,
      default: () => ({
        payment_method: ['COD', 'KOMERCE'],
        bank_account_ids: [],
        bank_accounts: [],
      }),
    },
    disableNext: {
      type: Boolean,
      default: false,
    },
    hasInvalidPrice: {
      type: Boolean,
      default: false,
    },
    invalidPriceProducts: {
      type: Array,
      default: () => [],
    },
    bankAccounts: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    formData: {
      handler() {
        this.validateForm()
      },
      deep: true,
      immediate: true,
    },
    hasInvalidPrice() {
      this.validateForm()
    },
  },
  methods: {
    validateForm() {
      const methods = Array.isArray(this.formData.payment_method) ? this.formData.payment_method : []

      // If no payment method is selected at all
      if (methods.length === 0) {
        this.$emit('update:disable-next', true)
        return
      }

      const isCod = methods.includes('COD')
      const isBankTransfer = methods.includes('BANK_TRANSFER')
      const isKomerce = methods.includes('KOMERCE')

      // Validate bank transfer: must have at least 1 bank account selected
      let isBankTransferValid = true
      if (isBankTransfer) {
        const bankIds = Array.isArray(this.formData.bank_account_ids) ? this.formData.bank_account_ids : []
        isBankTransferValid = bankIds.length > 0
      }

      // Validate komerce: cannot have invalid price
      let isKomerceValid = true
      if (isKomerce) {
        isKomerceValid = !this.hasInvalidPrice
      }

      // If bank transfer is active but invalid (no account selected), disable next
      if (isBankTransfer && !isBankTransferValid) {
        this.$emit('update:disable-next', true)
        return
      }

      // If komerce is active but invalid and neither COD nor Bank Transfer is valid
      if (isKomerce && !isKomerceValid && !isCod && (!isBankTransfer || !isBankTransferValid)) {
        this.$emit('update:disable-next', true)
        return
      }

      const hasValidActiveMethod = isCod || (isBankTransfer && isBankTransferValid) || (isKomerce && isKomerceValid)
      this.$emit('update:disable-next', !hasValidActiveMethod)
    },
  },
}
</script>
